import {ChannelProcessorDisplay} from '@/components';
import type {AfriexTransactionType, CurrencySetting} from '@/types';
import {AfriexTransactionChannel} from '@/types';

import type {TransactionTypeTabProps} from './types';

export const TransactionTypeProcessors = ({
  transactionType,
  business,
  onRemove,
}: {
  transactionType: AfriexTransactionType;
  business: CurrencySetting;
  onRemove?: TransactionTypeTabProps['onRemoveProcessor'];
}) => {
  // Filter channels based on live currency data - only show channels with processors set
  const channels = Object.values(AfriexTransactionChannel).filter((channel) => {
    const currentProcessor =
      business[transactionType]?.[channel]?.currentProcessor;
    return !!currentProcessor;
  });

  if (channels.length === 0) {
    return (
      <div className="flex items-center justify-center h-32 text-gray-500 dark:text-gray-400">
        <div className="text-center">
          <p className="text-sm">No current payment processors configured</p>
          <p className="text-xs mt-1">
            for {transactionType.toLowerCase()} transactions
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="text-sm text-gray-600 dark:text-gray-400 mb-4">
        Current payment processors for {transactionType.toLowerCase()}{' '}
        transactions
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
        {channels.map((channel) => (
          <ChannelProcessorDisplay
            key={channel}
            channel={channel}
            currentProcessor={
              business[transactionType]?.[channel]?.currentProcessor
            }
            onRemove={onRemove}
            transactionType={transactionType}
          />
        ))}
      </div>
    </div>
  );
};
